import React, { createContext, useContext, useRef } from "react";
import { handleFocus } from "./tools/SkipLink.utils";

const SkipLinkContext = createContext<{
  handleFocusMain?: () => void;
  mainRef?: React.RefObject<HTMLElement>;
  handleFocusSidebarNavigation?: () => void;
  sidebarNavigationRef?: React.RefObject<HTMLElement>;
}>({});

const SkipLinkProvider = ({ children }: { children: React.ReactNode }) => {
  const mainRef = useRef<HTMLElement | null>(null);
  const sidebarNavigationRef = useRef<HTMLElement | null>(null);
  const handleFocusMain = () => handleFocus(mainRef);
  const handleFocusSidebarNavigation = () => handleFocus(sidebarNavigationRef);

  return (
    <SkipLinkContext.Provider value={{ handleFocusMain, mainRef, handleFocusSidebarNavigation, sidebarNavigationRef }}>
      {children}
    </SkipLinkContext.Provider>
  );
};

const useSkipLinkContext = () => useContext(SkipLinkContext);

export { SkipLinkProvider, useSkipLinkContext };
